import dayjs from 'dayjs'

export class UtilsIndex {
    static formatDate(dateStr: any, fmt: any) {
        const date = typeof dateStr === 'object' ? dateStr : new Date(Date.parse(dateStr.toString().replace(/-/g, '/')))
        const o: { [key: string]: any } = {
            'M+': date.getMonth() + 1, // 月份
            'd+': date.getDate(), // 日
            'h+': date.getHours(), // 小时
            'm+': date.getMinutes(), // 分
            's+': date.getSeconds(), // 秒
            'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
            S: date.getMilliseconds() // 毫秒
        }
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (const k in o) {
            if (new RegExp('(' + k + ')').test(fmt)) {
                fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
            }
        }
        return fmt
    }

    static DateFormat = (dataStr: number, pattern?: string) => {
        if (dataStr) {
            if (pattern) {
                return dayjs(dataStr).format(pattern)
            } else {
                return dayjs(dataStr).format('YYYY-MM-DD HH:mm:ss')
            }
        } else {
            return '-'
        }
    }

    static EmptyText = (value: any) => {
        if (value !== null) {
            return value
        } else {
            return '-'
        }
    }

    static mergeData(data: any, distData: any): any {
        for (let formKey in distData) {
            if (
                (typeof distData[formKey] === 'string' && distData[formKey] === '') ||
                (typeof distData[formKey] !== 'string' && typeof distData[formKey] !== 'number')
            ) {
                continue
            }
            data[formKey] = distData[formKey]
        }
        return data
    }

    static mergeData2(data: any, distData: any): any {
        for (let formKey in distData) {
            if (typeof distData[formKey] === 'string' && distData[formKey] === '') {
                continue
            }
            data[formKey] = distData[formKey]
        }
        return data
    }

    /**
     * 格式化金额
     * @param value
     */
    static clearNoNum(value: string): string {
        value = value.replace(/[^\d.]/g, '') // 清除"数字"和"."以外的字符
        value = value.replace(/^\./g, '') // 验证第一个字符是数字而不是字符
        value = value.replace(/\.{2,}/g, '.') // 只保留第一个.清除多余的
        value = value
            .replace('.', '$#$')
            .replace(/\./g, '')
            .replace('$#$', '.')
        value = value.replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两个小数
        return value
    }


    /**
     * 自定义金额格式
     */
    static formatARSCompat(amount: number | string): string {
        let value = Number(amount)
        if (Number.isNaN(value)) {
            return '0,00 ARS'
        }
        const negative = value < 0
        value = Math.abs(value)
        const fixed = value.toFixed(2)
        const [intPart, decimalPart] = fixed.split('.')
        const withThousands = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        return `${negative ? '-' : ''}${withThousands},${decimalPart} ARS`
    }

    /**
     * 自定义日期格式
     */
    static formatDateTimeHs(timestamp: number | string): string {
        if (!timestamp) return ''
        const date = new Date(Number(timestamp))
        if (Number.isNaN(date.getTime())) {
            return ''
        }
        const formatter = new Intl.DateTimeFormat('en-GB', {
            timeZone: 'America/Argentina/Buenos_Aires',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        })
        const parts = formatter.formatToParts(date)
        const map: any = {}
        parts.forEach(p => {
            if (p.type !== 'literal') {
                map[p.type] = p.value
            }
        })
        return `${map.day}/${map.month}/${map.year} ${map.hour}:${map.minute}hs`
    }

    /**
     * 判断对象里是否有空值
     */
    static hasEmptyValue(obj: Record<string, any>): boolean {
        return Object.values(obj).some(value => {
            if (value === null || value === undefined) {
                return true
            }
            if (typeof value === 'string' && value.trim() === '') {
                return true
            }
            return false
        })
    }

    /**
     * 种子算法
     * 随机生成开头不为0的九位数
     */
    static generateSeed9(userId: string | number): number {
        const str = String(userId)
        let hash = 0

        for (let i = 0; i < str.length; i++) {
            hash = (hash * 31 + str.charCodeAt(i)) >>> 0
        }

        return (hash % 900_000_000) + 100_000_000
    }
}
